import React, {Dispatch, useEffect} from "react"
import Modal from "../Modal"
import {useFormik} from "formik"
import {authSlice} from "../../../../store/slices/authSlice"
import {useAppDispatch, useAppSelector} from "../../../../hooks/redux"
import Input from "../../../generic/dataEntry/Input/Input"
import validEmail from "../../../../utils/validEmail"
import {sendRecoveryEmail} from "../../../../store/actions/authActions"
import classes from "../Modal/Modal.module.scss"

interface IModalForgottenPasswordProps {
  modalToggle: Dispatch<any>
  emailSentSuccess: Dispatch<any>
}

function ModalForgottenPassword({modalToggle, emailSentSuccess}: IModalForgottenPasswordProps) {

  const dispatch = useAppDispatch()
  const {error} = useAppSelector(state => state.auth)

  const {values, touched, handleChange, handleReset} = useFormik({
    initialValues: {
      email: ""
    },
    onSubmit: () => {}
  })

  useEffect(() => {
    dispatch(authSlice.actions.clearError())
  }, [])

  const inputChangeHandler = (e: React.ChangeEvent) => {
    handleChange(e)
    const fieldName: any = e.target.getAttribute('name')

    if (error[fieldName]) {
      dispatch(authSlice.actions.clearFieldError(fieldName))
    }
  }

  const saveHandler = async () => {
    const email = values.email
    let error = ""

    if (!email) {
      error = "Укажите E-mail"
    }

    if (!validEmail(email)) {
      error = "Невалидный E-mail"
    }

    if (!error) {
      const isSent = await dispatch(sendRecoveryEmail(email))
      if (isSent) {
        modalToggle(false)
        emailSentSuccess(true)
      }
    } else {
      dispatch(authSlice.actions.fieldError([{field: "email", message: error}]))
    }
  }

  const closeHandler = () => {
    modalToggle(false)
    dispatch(authSlice.actions.clearError())
  }

  return (
    <Modal
      title={"Забыли пароль?"}
      close={closeHandler}
      dialogSizeSuffix={`w435`}
      submitClick={saveHandler}
      cancelClick={closeHandler}
      submitText={`Отправить`}
      headerAlignCenter
    >
      <form
        className={classes.form}
      >
        <div className={classes.form_description}>
          <p>Введите адрес электронной почты, привязанный к вашей учетной записи. Вы получите письмо, со ссылкой для смены пароля.</p>
        </div>
        <div className={classes.form_field}>
          <Input
            value={values.email}
            onChange={(e: React.ChangeEvent) => {
              inputChangeHandler(e)
            }}
            name={"email"}
            label={"E-mail"}
            valid={!error.email}
            errorMessage={error.email}
            touched={touched.email}
            shouldValidate
            required
          />
        </div>
      </form>
    </Modal>
  )
}

export default ModalForgottenPassword